import React from 'react';
import PropTypes from 'prop-types';

function R1Button({ active, activeColor, color }) {
  return (
    <path
      d="M558.556 120.278V109.594C558.556 109.594 575.645 102.471 598.796 102.471C621.942 102.471 638.524 113.918 638.524 113.918V123.331L558.556 120.278Z"
      fill={active ? activeColor : color}
    />
  );
}

R1Button.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  color: PropTypes.string,
};

R1Button.defaultProps = {
  active: false,
  activeColor: '#FFFFFF',
  color: '#000201',
};

export default R1Button;
